<template>
  <div class="register-page" :style="fieldStyle" :class="[screenType, getPosition == 'LEFT' && screenType != 'smartphone' ? 'right' : 'left']">
    <div class="register-page-content">
      <div v-if="!isApp" class="redirect mt-4" align-center :style="getToolbarColor" @click="back">
        <v-icon class="ml-2" large dark :style="getArrowStyle">west</v-icon>
        <div>
          <span v-if="screenType === 'smartphone'" class="text" :style="getReturnBtnStyle">&nbsp;</span>
          <span v-else class="text" :style="getArrowStyle">VOLTAR</span>
        </div>
      </div>
      <div class="form-outside">
        <div class="form">
          <h2 class="page-title">Cadastro</h2>
          <div class="form-fields">
            <div v-if="!loading" ref="form">
              <div class="col-100">
                <v-text-field
                  v-if="isBrazilSelectedCountry"
                  :key="inputCpfCnpj"
                  v-mask="documentMask"
                  disabled
                  outlined
                  :label="getDocType"
                  :value="getDocNo"
                />
                <v-text-field v-else :key="inputForeignDocument" disabled outlined :label="getDocType" :value="getDocNo.replaceAll('.', '')" />
                <div v-if="isApp">
                  <v-text-field
                    v-for="(elem, index) in getFieldsForApp"
                    :key="index"
                    :ref="`${elem.name}`"
                    class="my-6"
                    disabled
                    outlined
                    :label="elem.label"
                    :field="elem.name"
                    :mask="elem.mask"
                    :placeholder="elem.placeholder"
                    :backend="elem.backend"
                    :value="USER_INFO[elem.name]"
                  />
                </div>
              </div>

              <div v-if="!isApp">
                <template v-for="(elem, index) in getFields">
                  <component
                    :is="elem.type"
                    v-if="showField(elem.visible)"
                    :key="index"
                    :ref="`${elem.name}`"
                    :label="elem.label"
                    :field="elem.name"
                    :width="elem.width"
                    :validator="elem.validators"
                    :mask="elem.mask"
                    :placeholder="elem.placeholder"
                    :options="elem.options"
                    :backend="elem.backend"
                    :extra_data="elem.extra_data"
                  />
                </template>
              </div>

              <div v-if="isShowDeleteButtons" :class="[screenType === 'desktop' ? 'ml-3' : '']" class="data-delete my-5">
                <span class="data-delete-title mb-2">Deletar dados</span>
                <div class="delete-buttons">
                  <quit-club-modal />
                  <data-remove-modal />
                </div>
              </div>
              <div v-if="!isApp" class="terms-check">
                <div class="checkbox-area my-3" @click.stop="termosDialog = true">
                  <v-checkbox v-model="termsVersion" class="py-2" hide-details :disabled="blockCheckbox" :value="getTermsVersion" :label="getCheckboxLabel" />
                </div>
                <termo-adesao v-if="termosDialog" :dialog.sync="termosDialog" @agree="handleAgreeTerms">
                  <span v-html="getTerms"></span>
                </termo-adesao>
                <div v-if="isShowChallengeCaptcha" class="mb-5">
                  <captcha action="SIGNUP" @input="challengeCaptchaV2" />
                </div>
                <div class="action-buttons">
                  <v-btn
                    :disabled="termsVersion == null"
                    class="register-button mr-2 button-height"
                    :loading="loading || loadingCaptcha"
                    :color="getAssets.colors.form.buttonBackground"
                    :style="{ color: getAssets.colors.form.buttonFont }"
                    @click="submit"
                    >{{ isLogged ? 'atualizar cadastro' : 'cadastrar' }}</v-btn
                  >
                  <v-btn text :loading="loading" class="cancel-button button-height" color="#B3280D" @click="back">cancelar e sair</v-btn>
                </div>
              </div>
              <v-snackbar v-model="snackbarError" left color="#B3280D">
                {{ snackbarErrorMessage }}
                <template v-slot:action="{ attrs }">
                  <v-btn color="white" text v-bind="attrs" @click="snackbarError = false">
                    fechar
                  </v-btn>
                </template>
              </v-snackbar>
            </div>
          </div>
        </div>
      </div>
      <div ref="image" class="register-page-image">
        <img :src="getSideImage" @load="imageLoad" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import marked from 'marked'
import { screenTypeMixin } from '@/mixins/screen-type'
import { documentMaskMixin } from '@/mixins/document-mask'
import { resizeImageHeight } from '@/helpers/resize-image-height'
import { mapGetters, mapMutations } from 'vuex'

const BRAZIL_DDI = '55'

export default {
  inject: ['$validator'],
  components: {
    FormAddress: () => import('@/components/dynamic/FormAddress'),
    FormText: () => import('@/components/dynamic/FormText'),
    FormCheckbox: () => import('@/components/dynamic/FormCheckbox'),
    FormRadio: () => import('@/components/dynamic/FormRadio'),
    FormSelect: () => import('@/components/dynamic/FormSelect'),
    FormDate: () => import('@/components/dynamic/FormDate'),
    FormPassword: () => import('@/components/dynamic/FormPassword'),
    TermoAdesao: () => import('@/components/modals/TermoAdesao'),
    QuitClubModal: () => import('@/modules/users/views/components/QuitClubModal'),
    DataRemoveModal: () => import('@/modules/users/views/components/DataRemoveModal'),
    Captcha: () => import('@/modules/users/views/components/Captcha')
  },
  mixins: [screenTypeMixin, documentMaskMixin],
  data: () => ({
    snackbarErrorMessage: '',
    snackbarError: false,
    termosDialog: false,
    blockCheckbox: true,
    termsVersion: null,
    cadastro: {},
    emailIsUnique: true,
    endereco: {},
    inputCpfCnpj: 0,
    inputForeignDocument: 0,
    // Captcha
    captchaChallengeMode: '',
    unchallengedCaptchaToken: null,
    challengedCaptchaToken: null
  }),
  computed: {
    ...mapGetters([
      'ALLOWED_MODULES',
      'TOKEN',
      'IS_APP',
      'GET_ACCOUNT_ID',
      'GET_ASSETS',
      'GET_TERMS',
      'GET_FIELDS',
      'GET_POSITION',
      'SHOW_DELETE_BUTTONS',
      'LOADING',
      'LOADING_CAPTCHA',
      'SOCIAL_MEDIA',
      'USER_INFO'
    ]),
    isInternacionalModuleActive() {
      return Boolean(this.ALLOWED_MODULES.hotsite_international) && this.allowedCountries.length > 0
    },
    isShowDeleteButtons() {
      if (this.isApp) return this.isLogged
      return this.isLogged && this.showDeleteButtons
    },
    isShowChallengeCaptcha() {
      return !this.isLogged && Boolean(this.ALLOWED_MODULES.captcha) && this.captchaChallengeMode === 'CHALLENGE'
    },
    isUseCaptcha() {
      return !this.isLogged && Boolean(this.ALLOWED_MODULES.captcha)
    },
    isLogged() {
      return this.TOKEN
    },
    isApp() {
      return this.IS_APP
    },
    getFieldsForApp() {
      return this.getFields.filter(field => ['name', 'email'].includes(field.name))
    },
    formattedFields() {
      return Object.values(this.$refs).reduce((obj, ref) => {
        if (Array.isArray(ref) && ref.length === 1) {
          const componentValue = ref[0].componentValue
          if (componentValue) {
            _.merge(obj, componentValue)
          }
        }
        return obj
      }, {})
    },
    accountId() {
      return this.GET_ACCOUNT_ID
    },
    getAssets() {
      return this.GET_ASSETS
    },
    getTerms() {
      return marked(this.GET_TERMS.content)
    },
    getTermsVersion() {
      return this.GET_TERMS.version
    },
    getDocNo() {
      if (this.$route.query.natural || this.$route.query.legal) {
        return this.$route.query.natural || this.$route.query.legal
      }
      return this.USER_INFO.document_no
    },
    getDocType() {
      if (!this.isBrazilSelectedCountry) {
        if (this.selectedCountry === 'ARGENTINA') {
          if (this.$route.query.natural || this.$route.query.legal) {
            return this.$route.query.natural ? 'CUIL' : 'CUIT'
          }
          return this.USER_INFO.person_type === 'N' ? 'CUIL' : 'CUIT'
        } else if (this.selectedCountry === 'URUGUAY') {
          if (this.$route.query.natural || this.$route.query.legal) {
            return this.$route.query.natural ? 'CI' : 'RUT'
          }
          return this.USER_INFO.person_type === 'N' ? 'CI' : 'RUT'
        }
      }
      if (this.$route.query.natural || this.$route.query.legal) {
        return this.$route.query.natural ? 'CPF' : 'CNPJ'
      }
      return this.USER_INFO.person_type === 'N' ? 'CPF' : 'CNPJ'
    },
    getFields() {
      if (this.$route.query.natural || this.$route.query.legal) {
        if (this.$route.query.natural) return this.GET_FIELDS.natural
        return this.GET_FIELDS.legal
      }
      return this.USER_INFO.person_type === 'N' ? this.GET_FIELDS.natural : this.GET_FIELDS.legal
    },
    getPosition() {
      return this.GET_POSITION
    },
    showDeleteButtons() {
      return this.SHOW_DELETE_BUTTONS
    },
    fieldStyle() {
      return {
        '--button-background-color': [this.getAssets.colors.form.buttonBackground],
        '--button-text-color': [this.getAssets.colors.form.buttonFont]
      }
    },
    loading() {
      return this.LOADING
    },
    loadingCaptcha() {
      return this.LOADING_CAPTCHA
    },
    getSideImage() {
      return this.getAssets.images.form[this.screenType]
    },
    getLogo() {
      return this.getAssets.images.form.smartphone
    },
    getReturnBtnStyle() {
      // if (this.screenType === 'smartphone' && this.getLogo === '') {
      //   return {
      //     color: this.getAssets.colors.primaryButtonFont,
      //     backgroundColor: this.getAssets.colors.primaryButtonBackground
      //   }
      // }
      return {
        color: this.getContrast === 'light' ? '#FFF' : 'rgba(0, 0, 0, 0.87)',
        background: `url(${this.getLogo}) center right 20px no-repeat`
      }
    },
    getContrast() {
      return this.$contrastHex(this.getAssets.colors.form.toolbar)
    },
    getArrowStyle() {
      if (this.screenType === 'smartphone' && this.getLogo !== '')
        return { color: this.getContrast === 'dark' ? 'rgba(0, 0, 0, 0.87)' : this.getAssets.colors.form.toolbar }
      return { color: this.getContrast === 'light' ? '#FFF' : 'rgba(0, 0, 0, 0.87)' }
    },
    getToolbarColor() {
      if (this.screenType === 'smartphone' && this.getLogo !== '') return { backgroundColor: '#FFF' }
      return { backgroundColor: this.getAssets.colors.form.toolbar }
    },
    getCheckboxLabel() {
      return this.blockCheckbox ? 'Clique para ler e aceitar os termos de adesão' : 'Li e aceito os termos de adesão'
    },
    getSocialMedia() {
      const socialMedia = Object.entries(this.SOCIAL_MEDIA)
      return socialMedia.filter(media => media[1] && media[0] !== 'whatsapp')
    },
    getWhatsapp() {
      return this.SOCIAL_MEDIA.whatsapp ? this.SOCIAL_MEDIA.whatsapp.find(number => number.show_in_hotsite) : {}
    },
    hasSocialMedia() {
      return !!(this.getSocialMedia.length || (this.getWhatsapp && this.getWhatsapp.link))
    }
  },
  watch: {
    screenType(newVal, oldVal) {
      if (newVal !== oldVal) {
        const time = setTimeout(() => {
          this.resizeImage()
          clearTimeout(time)
        }, 100)
      }
    },
    isBrazilSelectedCountry() {
      this.forceRerenderInputs()
    }
  },
  created() {
    const time = setTimeout(() => {
      let input = this.$refs.name[0] ? this.$refs.name[0].$el.getElementsByTagName('input') : undefined
      if (input) input[0].focus()
      clearTimeout(time)
    }, 500)
  },
  mounted() {
    window.addEventListener('resize', this.resizeImage)
    window.addEventListener('scroll', () => resizeImageHeight('.register-page-image', '.register-page-content', this.hasSocialMedia))
    window.addEventListener('orientationchange', this.resizeImage)

    this.resizeImage()
    resizeImageHeight('.register-page-image', '.register-page-content', this.hasSocialMedia)
    this.$validator.localize('pt-BR', this.$route.meta.configurations.dictionary)
    if (this.$route.query.natural) {
      this.cadastro.document_no = this.$route.query.natural
      this.cadastro.person_type = 'N'
    } else if (this.$route.query.legal) {
      this.cadastro.document_no = this.$route.query.legal
      this.cadastro.person_type = 'L'
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeImage)
    window.removeEventListener('scroll', () => resizeImageHeight('.register-page-image', '.register-page-content', this.hasSocialMedia))
  },
  methods: {
    forceRerenderInputs() {
      this.inputCpfCnpj += 1
      this.inputForeignDocument += 1
    },
    back() {
      this.cadastro = {}
      this.$store.commit('USER_INFO', {})
      this.$store.commit('ACCESS_TOKEN', null)
      this.$router.push('home').catch(() => {})
    },
    imageLoad() {
      this.resizeImage()
    },
    handleAgreeTerms() {
      this.termosDialog = false
      this.blockCheckbox = false
      this.termsVersion = this.getTermsVersion
    },
    showField(visible) {
      if (this.isLogged) return true
      return visible
    },
    createObjectToSave({ ddi }) {
      return {
        user: {
          ...this.cadastro,
          ...this.formattedFields,
          ddi: ddi.replace(/\D/g, '')
        },
        loyalty_terms: {
          version: this.termsVersion,
          timestamp: new Date().toISOString()
        }
      }
    },
    async submit() {
      const valid = await this.$validator.validate()
      let validPassword = true

      const refEmail = Object.keys(this.$refs).find(field => field.includes('email'))
      const passwordField = this.getFields.filter(field => field.name === 'password')
      const reqEmail = this.$refs[refEmail][0].$validator.flags.email.required
      const validEmail = this.$refs[refEmail][0].validateEmail() || !reqEmail

      const refPhone = this.$refs.phone[0]
      let ddi = BRAZIL_DDI

      if (refPhone && this.isInternacionalModuleActive) {
        ddi = refPhone.getDDIs ? refPhone.getDDIs[refPhone.selectCountryLocal ? refPhone.selectCountryLocal : 'BRASIL'] : BRAZIL_DDI
      }

      if (!this.isLogged && passwordField.visible) {
        const refPassword = Object.keys(this.$refs).find(field => field.includes('password'))
        validPassword = this.$refs[refPassword][0].validatePassword()
      }

      if (!valid || !validPassword || !validEmail) {
        this.focusOnFirstErrorInput()
        return
      }

      let formData = {
        ...this.createObjectToSave({ ddi })
      }

      if (this.isUseCaptcha) {
        // Passive captcha (v3) check, if this succeeds
        // the user does not see a challenge box
        if (!this.isShowChallengeCaptcha) {
          const captchaValidated = await this.challengeCaptchaV3()
          if (!captchaValidated) {
            this.snackbarErrorMessage = 'Falha ao validar autenticidade da operação'
            this.snackbarError = true
            return
          }
        }

        // If user is seeing a challenge box, it must have a challenged token to proceed
        // challengeCaptcha can set isShowChallengeCaptcha to true
        // so this cannot be an else
        if (this.isShowChallengeCaptcha && !this.challengedCaptchaToken) {
          this.snackbarErrorMessage = 'Preencha o captcha para prosseguir'
          this.snackbarError = true
          return
        }

        if (this.isShowChallengeCaptcha) {
          formData.captcha = {
            version: 'V2',
            token: this.challengedCaptchaToken
          }
        } else {
          formData.captcha = {
            version: 'V3',
            token: this.unchallengedCaptchaToken
          }
        }
      }

      if (this.isLogged) {
        const { password, document_no, ...rest } = formData.user
        await this.$store
          .dispatch('updateUser', {
            user: rest,
            loyalty_terms: formData.loyalty_terms
          })
          .then(() => {
            this.$router.push({ path: 'dados-alterados' }).then(() => {
              setTimeout(() => {
                this.$store.commit('LOADING', false)
              }, 500)
            })
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        await this.$store
          .dispatch('createUser', formData)
          .then(response => {
            if (response.createUser) {
              this.$router
                .push({
                  path: 'finalizar',
                  query: { nome: formData.user.name, tipo: 'F', cpfCnpj: formData.user.document_no }
                })
                .then(() => {
                  setTimeout(() => {
                    this.$store.commit('LOADING', false)
                  }, 500)
                })
            }
          })
          .catch(error => {
            if (error.response.errors[0].message === 'Another user exist with this email/document_no combination') {
              this.text = 'Já existe um cadastro com o e-mail ou documento utilizado.'
            }
          })
      }
    },
    focusOnFirstErrorInput() {
      this.$nextTick(() => {
        const addressFields = ['bairro', 'uf', 'cidade', 'complemento', 'logradouro', 'numero', 'pontoReferencia']
        let firstInvalidField = this.$validator.errors.items[0].field
        firstInvalidField = addressFields.includes(firstInvalidField) ? 'address' : firstInvalidField
        const input = this.$refs[firstInvalidField][0].$el.getElementsByTagName('input')[0]
        this.$vuetify.goTo(input, { offset: 200 })
        input.focus()
      })
    },
    resizeImage() {
      if (!this.$refs.image) return
      if (!this.$vuetify.breakpoint.xs) {
        this.$refs.image.style.height = `${window.innerHeight}px`
      } else {
        this.$refs.image.style.height = `100%`
      }
      resizeImageHeight('.register-page-image', '.register-page-content', this.hasSocialMedia)
    },
    async challengeCaptchaV3() {
      try {
        const challengeCaptchaResponse = await this.$store
          .dispatch('challengeCaptcha', { version: 'V3', document_no: this.getDocNo })
          .then(response => response.challengeCaptcha)
        this.captchaChallengeMode = challengeCaptchaResponse.mode
        this.unchallengedCaptchaToken = challengeCaptchaResponse.token
        return true
      } catch (error) {
        console.warn(error)
        return false
      }
    },
    async challengeCaptchaV2(token) {
      try {
        const challengeCaptchaResponse = await this.$store
          .dispatch('challengeCaptcha', { version: 'V2', document_no: this.getDocNo, token })
          .then(response => response.challengeCaptcha)
        this.challengedCaptchaToken = challengeCaptchaResponse.token
        return true
      } catch (error) {
        console.warn(error)
        return false
      }
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;
$desktop-size: 1024px;

.delete-buttons {
  & button {
    display: block;
  }
}

.action-buttons {
  display: flex;
  justify-content: flex-start;
}

.register-page {
  padding: 40px 0;
  $self: &;
  display: flex;
  width: 100%;
  &.right {
    justify-content: flex-end;
    #{$self}-image {
      left: 0;
      background-position: left center !important;
      background-size: auto 100% !important;
    }
    &-content {
      display: flex;
      flex-direction: column;
      width: 50%;
      .form {
        padding: 40px 60px 0 0;
      }
    }
  }
  & .data-delete {
    &-title {
      display: block;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 22px;
      line-height: 26px;
    }
  }
  &-content {
    .form-outside {
      display: flex;
      justify-content: center;
    }
    .form {
      max-width: 850px;
      padding: 40px 20px 0;
      width: 100%;
    }
    .page-title {
      font-family: Roboto !important;
      font-style: normal !important;
      font-weight: normal !important;
      font-size: 32px !important;
      line-height: 37px;
      margin-bottom: 25px;
    }
  }
  &-image {
    display: flex;
    max-width: 600px;
    position: fixed;
    top: 0;
    right: 0;
    background-size: auto 100% !important;

    & image {
      display: block;
      width: 100%;
    }
  }
  &.desktop {
    .section-title {
      margin: 0 10px;
    }
    .redirect {
      .v-icon.v-icon {
        margin-left: 30px !important;
      }
    }
    .col-100 {
      clear: both;
      width: calc(100% - 20px);
      margin: 0 10px;
    }
    .col-70 {
      float: right;
      width: calc(85% - 20px);
      margin: 0 10px;
      .v-input {
      }
    }
    .col-50 {
      float: left;
      width: calc(50% - 20px);
      margin: 0 10px;
      .v-input {
      }
    }
    .col-30 {
      float: left;
      width: calc(15% - 20px);
      margin: 0 10px;
      .v-input {
      }
    }
    .page-title {
      margin-left: 10px;
    }
  }
  &.smartphone {
    .col-100 {
      clear: left;
    }
    .col-50 {
      width: 100%;
      margin-right: 0;
      .v-input {
      }
    }
    .v-input--selection-controls .v-input__slot > .v-label,
    .v-input--selection-controls .v-radio > .v-label {
      display: inline;
    }
  }
  &.smartphone {
    width: 100%;
    padding: 82px 0 0;
    #{$self}-content {
      width: 100%;
    }
    #{$self}-image {
      display: none;
    }
    .v-input__control {
      .v-text-field__details {
        display: none;
      }
    }
  }

  .redirect {
    z-index: 5;
    cursor: pointer;
    user-select: none;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
    height: 67px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 200px;
    border-radius: 0 5px 5px 0;
    .text {
      font-family: 'Roboto', medium;
      font-size: 18px;
      text-align: right;
      width: 100%;
      padding-right: 20px;
    }
    div {
      display: flex;
      width: inherit;
    }
    @media screen and (max-width: 599px) {
      height: 82px;
      margin-top: 0 !important;
      border-radius: 0;
      position: fixed;
      top: 0;
      width: 100%;
      .text {
        height: 82px;
        width: 100%;
        background-size: contain !important;
      }
      .v-icon.v-icon {
        margin-left: 20px !important;
      }
    }
    @media screen and (max-width: $tablet-size) {
      .redirect {
        .v-icon.v-icon {
          margin-left: 20px !important;
        }
      }
    }
    @media screen and (min-width: $tablet-size) {
      .redirect {
        .v-icon.v-icon {
          margin-left: 30px !important;
        }
      }
    }
  }
}
.terms-check {
  margin: 0 10px;

  & .checkbox-area {
    max-width: 360px;
    cursor: pointer;

    & .v-label {
      text-decoration: underline;
    }
  }
}

.col-50,
.col-100 {
  padding: 0 0 15px !important;
  .v-input__slot {
    &:first-child {
      margin-top: 0;
    }
  }
}
.ml-1 {
  text-decoration: underline;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0;
  padding: 5px 0 0 5px !important;
}
.block {
  .v-input__control {
    .v-text-field__details {
      display: block !important;
    }
  }
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)
  > .v-input__control
  > .v-input__slot:hover
  fieldset,
.v-application .primary--text {
  border-color: var(--button-background-color) !important;
  caret-color: var(--button-background-color) !important;
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)
  > .v-input__control
  > .v-input__slot:hover
  label,
.v-application .primary--text {
  color: var(--button-background-color) !important;
}

@media screen and (max-width: 1024px) and (min-width: 600px) {
  .register-page {
    .form-outside {
      display: flex;
      justify-content: center;
    }
    .form {
      max-width: 450px;
      padding: 40px 20px 0;
      width: 100%;
    }
    &-image {
      max-width: 305px;
    }
  }
}
@media screen and (max-width: 650px) and (min-width: 600px) {
  .action-buttons {
    display: block !important;
    text-align: left;
    & .cancel-button {
      margin-top: 8px;
    }
  }
}
</style>
